// ===== INTERACTIVE GOLD PARTICLE CANVAS =====
const canvas = document.getElementById('particles-canvas');
const ctx = canvas.getContext('2d');

let mouse = { x: -500, y: -500 };
let particles = [];
const PARTICLE_COUNT = 80;
const CONNECTION_DISTANCE = 150;
const MOUSE_RADIUS = 200;

function resizeCanvas() {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
}
resizeCanvas();
window.addEventListener('resize', resizeCanvas);

// Particle class
class Particle {
    constructor() {
        this.reset();
    }

    reset() {
        this.x = Math.random() * canvas.width;
        this.y = Math.random() * canvas.height;
        this.baseSize = Math.random() * 2 + 0.5;
        this.size = this.baseSize;
        this.speedX = (Math.random() - 0.5) * 0.5;
        this.speedY = (Math.random() - 0.5) * 0.5;
        this.opacity = Math.random() * 0.4 + 0.1;
        this.baseOpacity = this.opacity;
        // Gold color variations
        const goldShift = Math.random() * 30;
        this.r = 232 - goldShift;
        this.g = 184 - goldShift;
        this.b = 75 + Math.random() * 20;
    }

    update() {
        // Base movement
        this.x += this.speedX;
        this.y += this.speedY;

        // Mouse interaction - particles get pushed away gently and glow
        const dx = this.x - mouse.x;
        const dy = this.y - mouse.y;
        const dist = Math.sqrt(dx * dx + dy * dy);

        if (dist < MOUSE_RADIUS) {
            const force = (MOUSE_RADIUS - dist) / MOUSE_RADIUS;
            const angle = Math.atan2(dy, dx);
            this.x += Math.cos(angle) * force * 2;
            this.y += Math.sin(angle) * force * 2;
            this.size = this.baseSize + force * 3;
            this.opacity = Math.min(this.baseOpacity + force * 0.5, 0.8);
        } else {
            this.size += (this.baseSize - this.size) * 0.05;
            this.opacity += (this.baseOpacity - this.opacity) * 0.05;
        }

        // Wrap around edges
        if (this.x < -10) this.x = canvas.width + 10;
        if (this.x > canvas.width + 10) this.x = -10;
        if (this.y < -10) this.y = canvas.height + 10;
        if (this.y > canvas.height + 10) this.y = -10;
    }

    draw() {
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(${this.r}, ${this.g}, ${this.b}, ${this.opacity})`;
        ctx.fill();
        
        // Glow effect on brighter particles
        if (this.opacity > 0.3) {
            ctx.beginPath();
            ctx.arc(this.x, this.y, this.size * 3, 0, Math.PI * 2);
            ctx.fillStyle = `rgba(${this.r}, ${this.g}, ${this.b}, ${this.opacity * 0.15})`;
            ctx.fill();
        }
    }
}

// Create particles
for (let i = 0; i < PARTICLE_COUNT; i++) {
    particles.push(new Particle());
}

function drawConnections() {
    for (let i = 0; i < particles.length; i++) {
        for (let j = i + 1; j < particles.length; j++) {
            const dx = particles[i].x - particles[j].x;
            const dy = particles[i].y - particles[j].y;
            const dist = Math.sqrt(dx * dx + dy * dy);

            if (dist < CONNECTION_DISTANCE) {
                const opacity = (1 - dist / CONNECTION_DISTANCE) * 0.15;
                
                // Connections near mouse glow brighter
                const midX = (particles[i].x + particles[j].x) / 2;
                const midY = (particles[i].y + particles[j].y) / 2;
                const mouseDist = Math.sqrt(
                    (midX - mouse.x) ** 2 + (midY - mouse.y) ** 2
                );
                const mouseBoost = mouseDist < MOUSE_RADIUS 
                    ? (1 - mouseDist / MOUSE_RADIUS) * 0.3 
                    : 0;

                ctx.beginPath();
                ctx.moveTo(particles[i].x, particles[i].y);
                ctx.lineTo(particles[j].x, particles[j].y);
                ctx.strokeStyle = `rgba(232, 184, 75, ${opacity + mouseBoost})`;
                ctx.lineWidth = 0.5;
                ctx.stroke();
            }
        }
    }
}

// Mouse glow ring
function drawMouseGlow() {
    if (mouse.x < 0 || mouse.y < 0) return;
    
    const gradient = ctx.createRadialGradient(
        mouse.x, mouse.y, 0,
        mouse.x, mouse.y, MOUSE_RADIUS
    );
    gradient.addColorStop(0, 'rgba(232, 184, 75, 0.06)');
    gradient.addColorStop(0.5, 'rgba(232, 184, 75, 0.02)');
    gradient.addColorStop(1, 'rgba(232, 184, 75, 0)');
    
    ctx.beginPath();
    ctx.arc(mouse.x, mouse.y, MOUSE_RADIUS, 0, Math.PI * 2);
    ctx.fillStyle = gradient;
    ctx.fill();
}

function animate() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    
    drawMouseGlow();
    
    particles.forEach(p => {
        p.update();
        p.draw();
    });
    
    drawConnections();
    
    requestAnimationFrame(animate);
}
animate();

// ===== CURSOR FOLLOW =====
const cursor = document.querySelector('.cursor-follow');
document.addEventListener('mousemove', e => {
    mouse.x = e.clientX;
    mouse.y = e.clientY;
    cursor.style.left = e.clientX + 'px';
    cursor.style.top = e.clientY + 'px';
});

// Hide custom cursor on touch devices
if ('ontouchstart' in window) {
    cursor.style.display = 'none';
    document.body.style.cursor = 'auto';
    document.querySelectorAll('*').forEach(el => el.style.cursor = 'auto');
}

// ===== NAVIGATION STICKY =====
window.addEventListener('scroll', () => {
    document.getElementById('nav').classList.toggle('stuck', window.scrollY > 50);
});

// ===== SCROLL REVEAL =====
const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.style.opacity = "1";
            entry.target.style.transform = "translateY(0)";
        }
    });
}, { threshold: 0.1 });

document.querySelectorAll('.reveal').forEach(el => {
    el.style.opacity = "0";
    el.style.transform = "translateY(20px)";
    el.style.transition = "all 0.6s ease-out";
    observer.observe(el);
});